import { DISALLOWED_USERNAME_PATTERNS } from "#/shared/constants"

import { floatToBigInt } from "./numbers"

export const validateBalance = (
  value: string,
  balance: bigint,
  decimals: number = 18,
) => {
  const parsedValue = floatToBigInt(value, decimals)

  if (value === "" || parsedValue > balance || parsedValue < 0n) {
    return false
  }

  return true
}

export const validateMinimumTokenAmount = (
  tokenAmount: bigint,
  minTokenAmount: bigint,
) => tokenAmount >= minTokenAmount && tokenAmount > 0n

export const validateMaximumTokenAmount = (
  tokenAmount: bigint,
  maxTokenAmount: bigint,
) => tokenAmount <= maxTokenAmount && tokenAmount >= 0n

export const validateUsername = (username: string) => {
  const parsedUsername = username.trim()

  const errors = DISALLOWED_USERNAME_PATTERNS.flatMap(({ pattern }) =>
    pattern.test(parsedUsername) ? [pattern] : [],
  )

  if (errors.length > 0) return false

  return true
}
